import type {WidgetFragment as Widget} from 'nutshell-graphql-types';

import {TasksWidget} from '../../../core-entity/widgets/tasks-widget/tasks-widget';

import {useGetTasksForPeep} from './graphql/hooks/use-get-tasks-for-peep';
import GET_TASKS_FOR_PEEP from './graphql/queries/get-tasks-for-peep.graphql';

type Props = {
    peepId: string;
    widget: Widget;
};

export function PeepTasksWidget(props: Props) {
    const {tasks, isFirstLoad: isLoadingTasks} = useGetTasksForPeep(props.peepId);

    return (
        <TasksWidget
            tasks={tasks}
            isLoadingTasks={isLoadingTasks}
            entityId={props.peepId}
            widget={props.widget}
            refetchQueries={[{query: GET_TASKS_FOR_PEEP, variables: {peepId: props.peepId}}]}
            showReminderButton={true}
        />
    );
}
